import { FilterGroup } from '@customer/filters/types';
import useFilters from '@customer/filters/useFilters';
import {
  PartnerResourcesQueryParams,
  useGetPartnerResourcesQuery,
} from '@customer/store/apis/documentsApi';
import { useAppSelector } from '@customer/store/hooks';
import { useMemo } from 'react';

// The purpose of this hook is to make it easier to keep the query identical between parent and child components for the sake of caching.
export const usePartnerResource = () => {
  const sidePanelModelId = useAppSelector(state => state.global.sidePanelModelId);

  const filters = useFilters<PartnerResourcesQueryParams>(FilterGroup.PartnerResources);

  const { data, error } = useGetPartnerResourcesQuery(filters, {
    refetchOnMountOrArgChange: true,
    refetchOnReconnect: true,
    skip: sidePanelModelId === undefined,
  });

  const matchedItem = useMemo(() => {
    if (data && sidePanelModelId) {
      const lookupId = parseInt(sidePanelModelId);
      return data.items.find(i => i.id === lookupId);
    }

    return undefined;
  }, [sidePanelModelId, data]);

  return {
    doc: matchedItem,
    error,
  };
};

export default usePartnerResource;
